// extracted by mini-css-extract-plugin
var _1 = "_preciousMetalTable-module__container";
var _2 = "_preciousMetalTable-module__table-container";
var _3 = "_preciousMetalTable-module__title";
export { _1 as "container", _2 as "table-container", _3 as "title" }
